// extracted by mini-css-extract-plugin
export var growableInput = "_6x-0";
export var tagContainer = "_6x-2";
export var textInput = "_6x-1";